window.initInfoBlocks = function() {
  var divider = 3;
  if($(window).outerWidth() < 1000) {
    divider = 2;
  }
  if($(window).outerWidth() < 500) {
    divider = 1;
  }
  if($('#neos-application').length) {
    divider = 1;
  }

  unify('.info-block');

  $('.info-block').each(function() {
    $(this).find('.contents').css('bottom','');
    $(this).off('mouseenter').off('mouseleave');

    var elem = $(this).find('.contents');

    // Init hover effects
    var hidden = '-' + (parseInt(elem.outerHeight()) - parseInt(elem.find('.head').outerHeight(true)) - 5) + 'px';

    if(!isMobile() && !$('#neos-application').length) {
      elem.css('bottom',hidden);

      if($(this).find('.text').html() !== undefined && $(this).find('.text').html() !== '') {
        $(this).on('mouseenter',function (e) {
          elem.css('bottom','0');
        })
        $(this).on('mouseleave',function (e) {
          elem.css('bottom',hidden);
        })
      }
    } else if(isMobile()) {
      if($(this).find('.text').html() !== undefined && $(this).find('.text').html() !== '') {
        elem.css('bottom','0');
      } else {
        elem.css('bottom',hidden);
      }
    } else {
      elem.css('bottom','');
    }

    // Set width in relation to slider container - HOTFIX
    var containerwidth = $(this).parents('.info-slider-container').outerWidth() / divider;
    $(this).css('min-width',containerwidth);
    $(this).css('width',containerwidth);
  })

  $(window).off('resize',window.initInfoBlocks).on('resize',window.initInfoBlocks);
}
